export const POST_SELLER_PRODUCT_REQUEST="POST_SELLER_PRODUCT_REQUEST";
export const POST_SELLER_PRODUCT_SUCCESS="POST_SELLER_PRODUCT_SUCCESS";
export const POST_SELLER_PRODUCT_FAILED = "POST_SELLER_PRODUCT_FAILED";
